import { MapPin, Clock, Phone } from "@phosphor-icons/react";
import { WHATSAPP } from "@/components/public/PublicNav";

export default function Ubicacion() {
  return (
    <div>
      <section className="max-w-7xl mx-auto px-6 pt-16 pb-12">
        <div className="text-xs uppercase tracking-[0.25em] text-brand font-semibold mb-3">Visítanos</div>
        <h1 className="font-display text-5xl md:text-7xl font-black tracking-tight leading-[0.95]">Te esperamos<br />en López Rayón 43.</h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-24 grid md:grid-cols-5 gap-6">
        <div className="md:col-span-3 rounded-3xl overflow-hidden border border-zinc-200 aspect-[4/3] md:aspect-auto md:min-h-[480px]">
          <iframe
            title="Ubicación J.R. Tacos El Paisa"
            data-testid="ubicacion-map"
            src="https://www.google.com/maps?q=Lopez+Rayon+43,+San+Cristobal+Ecatepec&output=embed"
            className="w-full h-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <aside className="md:col-span-2 space-y-4">
          <div className="bg-white rounded-3xl border border-zinc-200 p-7">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-brand/10 text-brand flex items-center justify-center"><MapPin size={26} weight="fill" /></div>
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-1">Dirección</div>
                <div className="font-display text-xl font-bold leading-snug">López Rayón 43</div>
                <div className="text-zinc-600">San Cristóbal Ecatepec, Edo. Méx.</div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl border border-zinc-200 p-7">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-brand/10 text-brand flex items-center justify-center"><Clock size={26} weight="fill" /></div>
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-1">Horario</div>
                <div className="font-display text-xl font-bold leading-snug">Lunes a Domingo</div>
                <div className="text-zinc-600">Hasta las 12 de la noche</div>
              </div>
            </div>
          </div>

          <a href={WHATSAPP} target="_blank" rel="noreferrer" className="block bg-emerald-500 hover:bg-emerald-600 transition-colors rounded-3xl p-7 text-white">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center"><Phone size={26} weight="fill" /></div>
              <div>
                <div className="text-xs uppercase tracking-[0.2em] opacity-80 mb-1">Contacto</div>
                <div className="font-display text-xl font-bold leading-snug">Pide por WhatsApp</div>
                <div className="opacity-90">Tu pedido en minutos</div>
              </div>
            </div>
          </a>
        </aside>
      </section>
    </div>
  );
}
